import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Trophy, Star } from 'lucide-react';
import { periodLabel } from './BadgeAnnouncement';

const API = `${window.location.origin}/api`;

export default function BadgeWinnersStrip() {
  const [data, setData] = useState(null);

  useEffect(() => {
    // Her zaman varsayılan dönem (bir önceki ay) — dönem seçiminden bağımsız
    axios.get(`${API}/badges/dashboard`)
      .then((res) => setData(res.data))
      .catch(() => setData(null));
  }, []);

  if (!data || !data.dashboardEnabled) return null;
  const firsts = (data.performance || []).filter((b) => b.rank === 1)
    .sort((a, b) => (a.tagName || '').localeCompare(b.tagName || '', 'tr'));
  const mentions = data.mention || [];
  if (firsts.length === 0 && mentions.length === 0) return null;

  return (
    <div data-testid="badge-winners-strip" className="flex flex-wrap items-center gap-x-5 gap-y-2 mt-2">
      {/* Dönem (ay) etiketi */}
      <div className="flex items-center gap-1.5 pr-1">
        <Trophy className="w-4 h-4 text-amber-400 flex-shrink-0" />
        <div className="leading-tight">
          <div data-testid="winners-period-label" className="text-xs font-semibold text-amber-600 uppercase tracking-wide whitespace-nowrap">
            {periodLabel(data.period)}
          </div>
          <div className="text-[10px] text-gray-400 whitespace-nowrap">Performans öncüleri</div>
        </div>
        <span className="hidden sm:inline w-px h-7 bg-gray-200 ml-1.5" />
      </div>
      {firsts.map((b) => (
        <div key={b.id} data-testid="winner-chip" className="flex items-center gap-2">
          <Trophy className="w-5 h-5 text-amber-500 flex-shrink-0" />
          <div className="leading-tight">
            <div className="text-sm font-bold text-gray-900">{b.userName}</div>
            <div className="text-[11px] text-gray-500">{b.tagName}</div>
          </div>
        </div>
      ))}
      {/* Mobilde mansiyon rozetleri bir alt satıra insin */}
      {mentions.length > 0 && <div className="basis-full h-0 sm:hidden" />}
      {mentions.map((b) => (
        <div key={b.id} data-testid="winner-mention-chip" className="flex items-center gap-2">
          <Star className="w-5 h-5 text-fuchsia-500 flex-shrink-0" />
          <div className="leading-tight">
            <div className="text-sm font-bold text-gray-900">{b.userName}</div>
            <div className="text-[11px] text-gray-500">Mansiyon</div>
          </div>
        </div>
      ))}
    </div>
  );
}
